import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { AppView } from "../../../../components/app/app-view";
import { searchString } from "../../../../lib/search";

interface KeysSearch {
  /** The key an AI asked for, e.g. ANTHROPIC_API_KEY. */
  ask?: string;
  /** The AI's name, e.g. Claude. */
  client?: string;
}

const ENV_NAME = /^[A-Z_][A-Z0-9_]{0,127}$/;

export const Route = createFileRoute("/_authed/a/$slug/keys")({
  validateSearch: (search: Record<string, unknown>): KeysSearch => {
    const out: KeysSearch = {};
    const ask = searchString(search.ask);
    const client = searchString(search.client);
    if (ask !== undefined && ENV_NAME.test(ask)) out.ask = ask;
    if (client !== undefined) out.client = client.slice(0, 40);
    return out;
  },
  component: KeysRoute,
});

function KeysRoute() {
  const { slug } = Route.useParams();
  const { ask, client } = Route.useSearch();
  const navigate = useNavigate();
  const onKeysClosed = useCallback(() => void navigate({ to: "/a/$slug", params: { slug }, replace: true }), [navigate, slug]);
  return <AppView key={slug} slug={slug} initialPanel="keys" ask={ask} aiName={client} onKeysClosed={onKeysClosed} />;
}
